// src/components/welcome/LoadingScreen.jsx
//
// Brief 2.5s transition spinner shown between landing and manager selection.
import React, { useEffect } from 'react';
import FPLLogo from '../shared/FPLLogo';

const LoadingScreen = ({ onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(() => onComplete?.(), 2500);
    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="h-full w-full flex flex-col items-center justify-center text-white relative overflow-hidden"
      style={{ background: 'var(--c-black)' }}
    >
      <div className="relative z-10 flex flex-col items-center gap-8">
        <FPLLogo size="icon" colour="light" className="h-10 opacity-60" />
        <div
          style={{
            width:        '36px',
            height:       '36px',
            border:       '2px solid rgba(63, 105, 174, 0.18)',
            borderTop:    '2px solid var(--c-blue)',
            borderRadius: '50%',
            animation:    'spin 0.9s linear infinite',
          }}
        />
      </div>
    </div>
  );
};

export default LoadingScreen;
